import { ExternalAccesoGuard } from './../../../core/guards/deactivate/external-acceso.guard';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AccesoEmpresaComponent } from './pages/acceso-empresa/acceso-empresa.component';
import { HomeEmpresaComponent } from './pages/home-empresa/home-empresa.component';
import { EmpresaComponent } from './empresa.component';

const EMPRESA_ROUTE: Routes = [{
  path: '',
  component: EmpresaComponent,
  children: [
    {
      path: '',
      pathMatch: 'full',
      redirectTo: 'acces'
    }
    ,
    {
      path: 'acces',
      component: AccesoEmpresaComponent,
      canActivate: [ExternalAccesoGuard],
      data: {
        authorities: [],
        pageTitle: 'EMPRESA.title'
      }
    }
    ,
    {
      path: 'home',
      component: HomeEmpresaComponent,
      data: {
        authorities: [],
        pageTitle: 'EMPRESA.title'
      }
    }]
}];

@NgModule({
  imports: [RouterModule.forChild(EMPRESA_ROUTE)],
  exports: [RouterModule]
})
export class EmpresaRoutingModule { }
